import React, { useEffect, useState } from 'react';
import { Text } from '@gjensidige/builders-components';
import {
  CalculationWidget,
  CalculationWidgetProps
} from '@gjensidige/se-common-calculation';
import { resolveCDNDir } from '@gjensidige/se-content-helpers';

import { WidgetProps } from '../interfaces/Types';
import { AppHelper } from '../utils/AppHelper';
import {
  ageResolver,
  isValidSSNOrCoordinationNumber
} from '../utils/CalculationHelper';
interface InputWidgetProps {
  enonicData: WidgetProps;
}

export const InputWidgetContainer: React.FC<InputWidgetProps> = ({
  enonicData
}: InputWidgetProps) => {
  const [personNumber, setPersonNumber] = useState('');
  const [validPersonNumber, isValidPersonNumber] = useState(false);
  const [personNumberErrorText, setPersonNumberErrorText] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const MIN_AGE = 18;
  const MAX_AGE = 69;
  const MIN_YEAR_PREFIX = 19;
  const bankIdIcon = `${resolveCDNDir()}images/BankID_nopadding_simple.svg`;

  useEffect(() => {
    const checkLoggedInStatus = async () => {
      const isUserLoggedIn = await AppHelper.checkLoginStatus();
      setIsLoggedIn(isUserLoggedIn);
    };
    checkLoggedInStatus();
  }, []);

  const handleOnChangePersonNumber = (event: any) => {
    event.preventDefault();
    const customerInput = event.currentTarget.value.replace(/\D/g, '');
    setPersonNumber(customerInput.toUpperCase());
    const isPersonNumberValid = cprAndAgeValidator({ age: 18 }, customerInput);
    isValidPersonNumber(isPersonNumberValid);
    console.log('isPersonNumberValid', isPersonNumberValid);
    if (!customerInput.length) {
      setPersonNumberErrorText('');
    }
  };

  const handleOnBlurPersonNumber = (event: any) => {
    event.preventDefault();
    const customerInput = event.currentTarget.value.replace(/\D/g, '');
    if (!customerInput.length) {
      setPersonNumberErrorText('');
    } else {
      if (validPersonNumber) {
        setPersonNumberErrorText('');
      } else {
        const age = ageResolver(customerInput);
        if (!isValidSSNOrCoordinationNumber(customerInput)) {
          setPersonNumberErrorText(enonicData.cprInvalidMessage);
        } else if (age !== null && age <= MIN_AGE) {
          setPersonNumberErrorText(enonicData.minAgeErrorText);
        } else if (age !== null && age >= MAX_AGE) {
          setPersonNumberErrorText(enonicData.maxAgeErrorText);
        }
      }
    }
  };

  const cprAndAgeValidator = (options: any, inputValue: any) => {
    if (
      (inputValue.length !== 10 && inputValue.length !== 12) ||
      (inputValue.length === 12 &&
        Number(inputValue.slice(0, 2)) < MIN_YEAR_PREFIX) ||
      !isValidSSNOrCoordinationNumber(inputValue)
    ) {
      return false;
    } else {
      const calculatedAge = ageResolver(inputValue);
      if (
        calculatedAge === null ||
        calculatedAge < MIN_AGE ||
        calculatedAge >= MAX_AGE
      ) {
        return false;
      }
      return true;
    }
  };

  const gotoNextStep = (event: any) => {
    event.preventDefault();
    const customerInfo = {
      cprNumber: personNumber,
      channel: 'hgfPPI'
    };
    sessionStorage.setItem('customerInfo', JSON.stringify(customerInfo));
    if (!isLoggedIn) {
      window.location.href =
        window.location.origin + `/kund/privat/webshop/%23/ppi/offer`;
    } else {
      window.location.href =
        window.location.origin + `/kund/privat/webshop/#/ppi/offer`;
    }
  };

  const getCprMoreInfoContent = () => {
    return (
      <Text>
        Vi behöver ditt personnummer för att kunna ge dig rätt pris.
        Personnumret ger oss bland annat uppgifter om var du bor och din ålder.
      </Text>
    );
  };

  const ppiParams: CalculationWidgetProps = {
    headerText: enonicData.headerText,
    image: AppHelper.getImageCDNPath(enonicData.imageInfo.image),
    smallScreenImage: AppHelper.getImageCDNPath(
      enonicData.imageInfo.smallScreenImage
    ),
    imageAltText: enonicData.imageInfo.imageAltText,
    inputLists: {
      calculationInputs: [
        {
          type: 'inputText',
          inputListInRow: [
            {
              id: 'cpr-number',
              labelText: enonicData.cprNumberLabel,
              name: 'input-cprNumber',
              onChange: handleOnChangePersonNumber,
              onBlur: handleOnBlurPersonNumber,
              value: personNumber,
              className: '',
              labelClassName: 'input-label-text',
              inputWrapperClassName: 'ssn',
              invalid: !validPersonNumber && !!personNumberErrorText,
              errorText: personNumberErrorText,
              helpText: '12 siffror ÅÅÅÅMMDDNNNN.',
              isHelpTextAlwaysVisible: true,
              inputMode: 'numeric',
              moreInfoModal: {
                linkText: 'Varför frågar vi om personnummer?',
                title: 'Personnummer',
                content: getCprMoreInfoContent(),
                closeLabel: 'Stäng hjälptext',
                ariaLabel: 'Hjälp om personnummer',
                wrapperClassName: 'cpr-modal-wrapper',
                ariaDescribedBy: 'cpr-more-info'
              }
            }
          ]
        }
      ],
      calculateBtn: {
        btnText: enonicData.calculateBtnLabel,
        onClick: gotoNextStep,
        enableTracking: true,
        disabled: !validPersonNumber,
        className: 'calculate-price mt-2',
        icon: <img src={bankIdIcon} className="bank-id-icon" />
      }
    },
    additionalInfoLinkText: enonicData.personalDataHandlingInfoLinkText,
    additionalInfoLink: enonicData.personalDataHandlinkUrl,
    footerMessage: enonicData.footerMessage
  };

  return <CalculationWidget {...ppiParams} />;
};
